module.exports = __webpack_public_path__ + "img/logo-sd.aa636fa4.png";